<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav minColor">产品</div></div>
                <div class="title">AGO</div>
                <div class="minTitle minColor">舟恩数字员工(AGO)是舟恩自主研发的RPA工具套件。数字员工根据设定的方案，模仿人工操作电脑，自动执行一系列的操作步骤。能够大幅提高效率、消除人因错误、降低成本。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
        <picture>
            <source srcset="@/assets/images/rpa1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/rpa1.png" />
        </picture>
       <div class="topBg">
            <div class="content pt20 blue-tit">
                <div class="title1 tc pb20">舟恩数字员工</div>
            </div>
            <div class="content pb20 flex">
                <div class="left">
                    <!-- <img src="@/assets/images/rpa2.png" />
                    <div class="lb title3">
                        产品特点
                    </div>
                    <div class="minTitle2 mt10">
                        以非侵入式的方式与现有的软件应用系统交互最大限度地保护现有IT资产。
                    </div> -->
                    <div class="item mt20">
                        <img src="@/assets/images/rpa3.png" />
                        <span>工作效率高于人工</span>
                    </div>
                    <div class="item mt20">
                        <img src="@/assets/images/rpa4.png" />
                        <span>工作时间不受限制</span>
                    </div>
                    <div class="item mt20">
                        <img src="@/assets/images/rpa5.png" />
                        <span>完全消除了人因差错</span>
                    </div>
                </div>
                <div class="right">
                    <div class="tit">
                        <img src="@/assets/images/rpa6.png" />
                        <div class="lb title3">
                            产品特点
                        </div>
                    </div>
                    <div class="minTitle2 mt10 p">
                        舟恩数字员（ArkGrace Operator）是完整的RPA工具套件。通过三种数字员工的协同，以非侵入式的方式与<br/>现有的软件应用系统交互，最大限度地保护现有IT资产。
                    </div>
                    <div class="flex">
                        <div class="item mt20">
                            <div class="tc title2 ry">
                                计划员
                            </div>
                            <div class="minTitle2 mt10">
                                制定任务书<br/>
                                精确定义每位操作员登录什么系统、下载什么资源、如何加工、做什么判断、提交哪些数据、保存哪些数据、有哪些业务路径。
                            </div>
                        </div>
                        <div class="item mt20">
                            <div class="tc title2 ry">
                                调度员
                            </div>
                            <div class="minTitle2 mt10">
                                制定工作计划、工单<br/>
                                根据“任务书”设计操作员的协同工作计划。为每一位操作员生成工单。下达工作指令并对执行过程进行监控。
                            </div>
                        </div>
                        <div class="item mt20 last">
                            <div class="tc title2 ry">
                                操作员
                            </div>
                            <div class="minTitle2 mt10">
                                根据调度员下发的工单执行操作，可7x24小时在岗。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">产品功能</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/rpa8.png" />
                            <div class="lb">
                                数据采集
                            </div>
                        </div>
                        <div class="minTitle2">
                            结合OCR读取纸质文档中的数据，整理后保存或者进一步处理（例如录入系统）。
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/rpa9.png" />
                            <div class="lb">
                                跨系统工作流
                            </div>
                        </div>
                        <div class="minTitle2">
                            通过“自动采集、识别、输入”，成为异构系统之间的“数据传送带”，实现业务自动流转。
                        </div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/rpa10.png" />
                            <div class="lb">
                                凭证审核
                            </div>
                        </div>
                        <div class="minTitle2">
                            采集原始凭证中关键数据，与系统中申请单进行比对。审核通过的可以进入下一个环节（例如审批、记账、发起付款等），不通过的创建人工审核任务。
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/rpa11.png" />
                            <div class="lb">
                                系统健康检查
                            </div>
                        </div>
                        <div class="minTitle2">
                            在设定的时间对多个终端的多个系统进行可用性确认。发现异常通知相关人员（例如终端用户、运维人员等）。
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/rpa12.png" />
                            <div class="lb">
                                多重发布
                            </div>
                        </div>
                        <div class="minTitle2">
                            根据设定的业务规则，抓取、计算后，将数据提交给多个发布渠道或者不同的用户。
                        </div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/rpa13.png" />
                            <div class="lb">
                                价格比对
                            </div>
                        </div>
                        <div class="minTitle2">
                            抓取不同电商的商品单价，如果满足预设条件则提醒相关人员。
                        </div>
                    </div>
                </div>
            </div>
       </div>

       <div class="botton">
            <div class="content">
                <div class="leftImg">
                    <img src="@/assets/images/rpa15.png" />
                </div>
                <div class="rightCon">
                    <div class="title1 mt20 tc pb20">应用场景</div>
                    <div class="tab" :class="tab == 1? 'active': ''" @click="tab = 1">保险公司数字员工</div>
                    <div class="tab" :class="tab == 2? 'active': ''" @click="tab = 2">风控部数字员工</div>
                    <div class="tab" :class="tab == 3? 'active': ''" @click="tab = 3">银行数字员工</div>
                    <div class="tab" :class="tab == 4? 'active': ''" @click="tab = 4">政务大厅数字员工</div>
                    <div class="tab" :class="tab == 5? 'active': ''" @click="tab = 5">财务部数字员工</div>
                    <div class="tabM">
                        <div class="tabCon" v-show="tab == 1">
                            <img class="titleImg" src="@/assets/images/rpa14.png" />
                            <div class="tabTitle">保险公司数字员工</div>
                            <div class="tabConItems">
                                <div class="minTitle2">RPA结合OCR解析文档、跨业务系统进行数据加工、转移、校验等大量重复性步骤。提高以下环节的效率和工作质量</div>
                                <div class="item">保单更新、取消</div>
                                <div class="item">风控</div>
                                <div class="item">索赔、核保</div>
                                <div class="item">财务处理</div>
                                <div class="item">同业数据分析</div>
                                <div class="item">监管报备</div>
                                
                            </div>
                        </div>
                        <div class="tabCon" v-show="tab == 2">
                            <img class="titleImg" src="@/assets/images/rpa14.png" />
                            <div class="tabTitle">风控部数字员工</div>
                            <div class="tabConItems">
                                <div class="minTitle2">数字员工解析被评估对象（无论是法人还是自然人）所提交的资料，再登录不同的数据来源系统对其进行数据验证、数据搜集，并形成初步的评估报告。</div>
                            </div>
                        </div>
                        <div class="tabCon" v-show="tab == 3">
                            <img class="titleImg" src="@/assets/images/rpa14.png" />
                            <div class="tabTitle">银行数字员工</div>
                            <div class="tabConItems">
                                <div class="minTitle2 pb5">· 采集信用数据</div>
                                <div class="minTitle2 pb5">· 征信查询</div>
                                <div class="minTitle2 pb5">· 对账</div>
                                <div class="minTitle2 pb5">· 监管报备：数字员工在本行核心系统中下载开户信息，并登陆这政府监管系统提交报备数据。</div>
                            </div>
                        </div>
                        <div class="tabCon" v-show="tab == 4">
                            <img class="titleImg" src="@/assets/images/rpa14.png" />
                            <div class="tabTitle">政务大厅数字员工</div>
                            <div class="tabConItems">
                                <div class="minTitle2">数字员工在同一个政府部门（甚或不同政府部门）不同的业务系统之间进行数据交换、整合和验证。效率远高于人工，压缩了办结时间，提升服务水准。</div>
                            </div>
                        </div>
                        <div class="tabCon" v-show="tab == 5">
                            <img class="titleImg" src="@/assets/images/rpa14.png" />
                            <div class="tabTitle">财务部数字员工</div>
                            <div class="tabConItems">
                                <div class="minTitle2 pb5">· 网银</div>
                                <div class="minTitle2 pb5">· 报税</div>
                                <div class="minTitle2 pb5">· 报销</div>
                                <div class="minTitle2 pb5">· 发票</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
       <div class="rpa-carousel">
        <div class="content">
            <div class="title1 tc">应用场景</div>
        </div>
        <div class="rpa-swiper">
            <el-carousel :height="flashHeight" arrow="never" ref="carousel" :autoplay="false">
                <el-carousel-item>
                    <div class="content flex">
                        <div class="img">
                            <img src="@/assets/images/rpa15.png" />
                        </div>
                        <div class="con">
                            <div class="tabTitle">保险公司数字员工</div>
                                <div class="tabConItems">
                                    <div class="minTitle2">RPA结合OCR解析文档、跨业务系统进行数据加工、转移、校验等大量重复性步骤。提高以下环节的效率和工作质量</div>
                                    <div class="item">保单更新、取消</div>
                                    <div class="item">风控</div>
                                    <div class="item">索赔、核保</div>
                                    <div class="item">财务处理</div>
                                    <div class="item">同业数据分析</div>
                                    <div class="item">监管报备</div>
                                </div>
                            </div>
                        </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="content flex">
                        <div class="img">
                            <img src="@/assets/images/rpa15.png" />
                        </div>
                        <div class="con">
                            <div class="tabTitle">风控部数字员工</div>
                                <div class="tabConItems">
                                    <div class="minTitle2">数字员工解析被评估对象（无论是法人还是自然人）所提交的资料，再登录不同的数据来源系统对其进行数据验证、数据搜集，并形成初步的评估报告。</div>
                                </div>
                            </div>
                        </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="content flex">
                        <div class="img">
                            <img src="@/assets/images/rpa15.png" />
                        </div>
                        <div class="con">
                            <div class="tabTitle">银行数字员工</div>
                                <div class="tabConItems">
                                    <div class="flex">
                                        <div class="minTitle2 pb5">· 采集信用数据</div>
                                        <div class="minTitle2 pb5">· 征信查询</div>
                                        <div class="minTitle2 pb5">· 对账</div>
                                        <div class="minTitle2 pb5">· 监管报备：数字员工在本行核心系统中下载开户信息，并登陆这政府监管系统提交报备数据。</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="content flex">
                        <div class="img">
                            <img src="@/assets/images/rpa15.png" />
                        </div>
                        <div class="con">
                            <div class="tabTitle">政务大厅数字员工</div>
                                <div class="tabConItems">
                                    <div class="minTitle2">数字员工在同一个政府部门（甚或不同政府部门）不同的业务系统之间进行数据交换、整合和验证。效率远高于人工，压缩了办结时间，提升服务水准。</div>
                                </div>
                            </div>
                        </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="content flex">
                        <div class="img">
                            <img src="@/assets/images/rpa15.png" />
                        </div>
                        <div class="con">
                            <div class="tabTitle">财务部数字员工</div>
                                <div class="tabConItems">
                                   <div class="flex">
                                        <div class="minTitle2 pb5">· 网银</div>
                                        <div class="minTitle2 pb5">· 报税</div>
                                        <div class="minTitle2 pb5">· 报销</div>
                                        <div class="minTitle2 pb5">· 发票</div>
                                   </div>
                                </div>
                            </div>
                        </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        
       </div>
    </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui'
    export default {
        components: {
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem
        },
        data() {
            return {
                flashHeight: '230px',
                tab: 1
            }
        },
        methods: {
            loadFlashImg() {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
                var that = this
                window.onresize = () => {
                    return (() => {
                        that.windowWidth = that.$refs.index.offsetWidth //获取屏幕宽度
                    })()
                }
            },
            startAuto() {
                var that = this
                if(that.autoplay == false){
                    that.autoplay = true;
                }
            },
            stopAuto() {
                var that = this
                if(that.autoplay == true){
                    that.autoplay = false;
                }
            },
            slideBanner1() {
                var that = this
                var box = document.querySelector('.rpa-swiper .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel.prev();
                        return;
                    }
                });
            },
        },
        watch: {
            windowWidth (val) {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
            }
        },
        mounted() {
            this.slideBanner1()
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .topBg {
            background-color: #FEF8F3;
            .flex {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
            }
        }
        .content {
            zoom: 1;
            overflow: hidden;
            .left {
                float: left;
                background-color: #ffffff;
                padding: 20px 2%;
                width: 23%;
                border-radius: 5px;
                min-height: 273px;
                img {
                    height: 30px;
                    width: 25px;
                    margin-right: 10px;
                }
                .lb {
                    display: inline-block;
                    font-weight: 500;
                    line-height: 35px;
                    vertical-align: bottom;
                }
                .item {
                    border-radius: 4px;
                    border: 1px solid #FFF1CD;
                    background-color: #FFF7E2;
                    padding: 18px 15px;
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 8px;
                    }
                    span {
                        color: #FA9F00;
                        font-size: 14px;
                        line-height: 25px;
                        vertical-align: bottom;
                    }
                }
            }

            .right {
                img {
                    height: 30px;
                    width: 30px;
                    margin-right: 10px;
                }
                .lb {
                    display: inline-block;
                    font-weight: 500;
                    line-height: 35px;
                    vertical-align: bottom;
                }
                float: right;
                padding: 20px 2%;
                width: 66%;
                border-radius: 5px;
                min-height: 273px;
                background: url(../../assets/images/rpa7.png) no-repeat;
                background-color: #ffffff;
                background-size: 168px 206px;
                background-position-x: 100%;
                zoom: 1;
                overflow: hidden;
                .item {
                    float: left;
                    padding: 20px 2%;
                    width: 27.99%;
                    margin-right: 2%;
                    background-color: #F5F6F9;
                    border-radius: 5px;
                    min-height: 135px;
                    .minTitle2 {
                        line-height: 20px;
                    }
                }
                .last {
                    margin-right: 0;
                }
            }
        }
        .lxwm {
            padding: 30px 0;
            .items {
                display: flex;
                flex-wrap: wrap;
                .item {
                    margin-top: 10px;
                    width: 10.66%;
                    background-color: #ffffff;
                    padding: 15px 3%;
                    text-align: center;
                    img {
                        height: 35px;
                    }
                    .lb {
                       margin-top: 10px;
                    }
                }

                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        margin-top: 10px;
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }

        .botton {
            min-height: 380px;
            background: url(../../assets/images/rpa16.png) no-repeat;
            background-size: cover;
            .leftImg {
                float: left;
                width: 35%;
                img {
                    width: 411px;
                    height: 278px;
                    margin-top: 70px;
                }

            }
            .rightCon {
                float: right;
                width: 63%;
                .title1 {
                    color: #ffffff;
                }
                .tab {
                    display: inline-block;
                    color: #ffffff;
                    font-size: 14px;
                    border: 1px solid #ffffff;
                    margin-right: 10px;
                    padding: 2px 10px;
                    border-radius: 20px;
                    cursor: pointer;
                }
                .tab.active {
                    background: -webkit-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -o-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -moz-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: linear-gradient(to right,#6BDEFF, #3C91FF);
                }
                .tabM {
                    margin-top: 15px;
                    border: 2px solid #2b4b87;
                    padding: 15px;
                    .tabCon {
                        background-color: #161644;
                        padding: 20px 10px 40px 10px ;
                        min-height: 130px;
                        .titleImg {
                            width: 30px;
                            height: 25px;
                            margin-right: 10px;
                        }
                        .tabTitle {
                            color: #36B9FE;
                            font-size: 14px;
                            line-height: 28px;
                            vertical-align: bottom;
                            display: inline-block;
                        }
                        .tabConItems {
                            padding: 15px 0 0 40px;
                            
                            .minTitle2 {
                                color: #ffffff;
                                padding-bottom: 15px;
                            }
                            .pb5 {
                                padding-bottom: 5px;
                            }
                            .item {
                                display: inline-block;
                                color: #ffffff;
                                background: url(../../assets/images/rpa17.png) no-repeat;
                                background-size: auto 80%;
                                background-position-y: center;
                                text-indent: 17px;
                                width: 24%;
                                margin-bottom: 5px;
                            }
                        }
                    }
                }
                    

            }
        }
        .rpa-carousel {
            display: none;
            .flex {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .rpa-swiper {
                padding: 35px 0 0;
                background: url(../../assets/images/rpa16.png) no-repeat;
                background-size: cover;
                .img {
                    width: 40%;
                    margin-right: 15px;
                    img {
                        width: 100%;
                    }
                }
                .con {
                    flex: 1;
                    color: #fff;
                    .tabTitle {
                        font-size: 16px;
                        text-align: center;
                        margin-bottom: 15px;
                    }
                    .minTitle2 {
                        font-size: 14px;
                        color: #fff;
                        margin-bottom: 15px;
                    }
                    .item {
                        width: 50%;
                        display: inline-block;
                        color: #ffffff;
                        background: url(../../assets/images/rpa17.png) no-repeat;
                        background-size: auto 80%;
                        background-position-y: center;
                        text-indent: 20px;
                        margin-bottom: 5px;
                    }
                    .flex {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: baseline;
                    }
                    .pb5 {
                        width: 50%;
                        display: inline-block;
                        margin-bottom: 5px;
                    }
                }
            }
            .title1 {
                font-size: 26px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
            }
        }
        
    }
    .ry::before {
        content: ' ';
        height: 16px;
        width: 20px;
        background: url(../../assets/images/jr3.png) no-repeat;
        background-size: 100%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
    }
    .mt40 {
        margin-top: 40px;
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
    .right {
        .minTitle2.p {
            padding-right: 35%;
        }
    }
  }
  .botton {
    .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .leftImg img {
            width: 95%;
            height: auto;
            margin-top: 0;
        }
        .rightCon {
            .tab {
                margin-bottom: 15px;
            }
            .tabM {
                margin-top: 0;
                .tabCon .tabConItems {
                    padding: 15px 0 0 0;
                }
            }
           
        } 
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        .title {
          font-size: 20px;
        }
        .minTitle {
          width: 40%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    } 
    .content {
        .flex {
            flex-wrap: wrap;
        }
        .left {
            width: 100%;
        }
        .right {
            width: 100%;
        }
    }
    .botton {
        display: none;
    }
    .rpa-carousel {
        display: block;
    }
  }
}
@media (max-width: 768px) {
    .index {
    .flash {
        padding: 0 15px;
        .minTitle {
            width: 50%;
            font-size: 13px;
        }
        .gg {
            top: 50px;
            .title {
                font-size: 20px;
            }
            .button {
                padding: 6px 15px;
                margin-top: 20px;
            }
        }
        
    }
    .flashImg {
        height: 40vh;
    }
    .blue-tit {
        background-color: #f6f8ff;
    }
    .content.pb20.flex {
        padding: 0;
    }
    .content {
        .left {
            padding: 20px 15px;
        }
        .right {
            background: unset;
            background-color: #f6f8ff;
            padding: 20px 15px;
            .minTitle2.p {
                padding-right: 0;
                font-size: 14px;
            }
            .tit {
                text-align: center;
                img {
                    display: none;
                }
            }
            .title3 {
                font-size: 20px;
                
            }
            .item {
                padding: 20px 15px;
                width: 100%;
                margin-right: 0;
                min-height: 100px;
                background-color: #fff;
                .minTitle2 {
                    font-size: 13px;
                }
            }
        }
    } 
    .lxwm {
        padding: 0 0 30px;
        .items {
            justify-content: space-between;
            .item2 {
                width: 49%;
                margin-right: 0;
                padding: 15px 10px;
                box-sizing: border-box;
                .tit {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }
                .lb {
                    font-size: 14px;
                    line-height: normal;
                }
                img {
                    height: 20px;
                }
                .minTitle2 {
                    font-size: 13px;
                }
            }
        }
    }
    .rpa-carousel {
       
        .rpa-swiper {
            .img {
                width: 35%;
                margin-right: 10px;
            }
            .con {
                .tabTitle {
                    font-size: 16px;
                }
                .minTitle2 {
                    font-size: 13px;
                    color: #fff;
                }
                .item {
                    font-size: 13px;
                    background-position: top left;
                    background-size: 16px 16px;
                }
            }
        }
        .title1 {
            font-size: 20px;
            margin-bottom: 20px;
        }
    }
    }
}
</style>